import React, {Fragment, useEffect, useState} from 'react';
import { useParams } from "react-router-dom";
import { FiCheck, FiX, FiClock } from "react-icons/fi";
import axios from 'axios';
import Confetti from 'react-confetti';
import Loading from 'react-fullscreen-loading';

import './index.scss';

function App() {
  const [progress, setProgress] = useState(null);
  const [step, setStep] = useState({ step: 'submit', percent: 0 });
  let { dealID } = useParams();

  useEffect(() => {
    const fetchStatus = async () => {
      const statusResponse = await axios.get(`https://onboarding.api.felloh.com/application/${dealID}/status`);

      setProgress(statusResponse.data.data.stage);
    };

    fetchStatus();
  }, []);

  useEffect(() => {
    if (progress) {
      const stage = { step: 'submit', percent: 0 };

      switch (progress) {
        case 'application_in_progress':
          stage.step = 'organisation';
          stage.percent = 10;
          break;
        case 'bank_details_provided':
          stage.step = 'organisation';
          stage.percent = 20;
          break;
        case 'posc_provided':
          stage.step = 'people-of-significant-control-entry';
          stage.percent = 30;
          break;
        case 'posc_validated':
        case 'contract_sent':
          stage.step = 'people-of-significant-control-verification';
          stage.percent = 40;
          break;
        case 'contract_received':
        case 'awaiting_total_processing_setup':
        case 'awaiting_nuvei_setup':
        case 'application_received':
          stage.step = 'contracts';
          stage.percent = 50;
          break;
        case 'processing_contract_sent':
        case 'processing_contract_signed':
          stage.step = 'contracts';
          stage.percent = 70;
          break;
        case 'technical_integration':
          stage.step = 'merchant-acquirer-onboarding';
          stage.percent = 80;
          break;
        case 'credentials_sent':
          stage.step = 'credentials-sent';
          stage.percent = 90;
          break;
        case 'merchant_processing':
          stage.step = 'complete';
          stage.percent = 100;
          break;
      }

      setStep(stage)
    }
  }, [progress]);

  return (
    <Fragment>
      { progress === 'merchant_processing'&& (
        <Confetti
          style={{ width: '100vw', 'height': '100vh' }}
          recycle={false}
          numberOfPieces={1000}
        />
      )}

      <div className="education">

        { !progress && (
          <Loading loading background="#670199" loaderColor="#fff" />
        )}

        { progress && (
          <React.Fragment>
            <div className="grid grid-cols-1 gap-x-8">

              <div className="education__content">
                <h5>Submit Organisation Details</h5>
                <span className={ step.percent > 0 ? 'year tick' : 'year' }>
                  { step.percent > 0 ? <FiCheck /> : <FiX /> }
                </span>
                <p>That you have completed the organisation information form</p>
              </div>

              <div className="education__content">
                <h5>Verify Bank Details</h5>
                <span className={ step.percent === 10 ? 'year pending' : step.percent >= 20 ? 'year tick' : 'year' }>
                  { step.percent === 10 ? <FiClock /> : step.percent >= 20 ? <FiCheck /> : <FiX /> }
                </span>
                <p>That you have verified your trading account details</p>
              </div>

              <div className="education__content">
                <h5>Verify people with significant control</h5>
                <span className={ step.percent === 20 ? 'year pending' : step.percent >= 30 ? 'year tick' : 'year' }>
                  { step.percent === 20 ? <FiClock /> : step.percent >= 30 ? <FiCheck /> : <FiX /> }
                </span>
                <p>That you have verified the people with significant control of your organisation</p>
              </div>

              <div className="education__content">
                <h5>People with significant Control verified</h5>
                <span className={ step.percent === 30 ? 'year pending' : step.percent >= 40 ? 'year tick' : 'year' }>
                  { step.percent === 30 ? <FiClock /> : step.percent >= 40 ? <FiCheck /> : <FiX /> }
                </span>
                <p>That all people with significant control have verified their identity using our verification service</p>
              </div>

              <div className="education__content">
                <h5>Sign Contracts</h5>
                <span className={ step.percent === 40 ? 'year pending' : step.percent >= 50 ? 'year tick' : 'year' }>
                  { step.percent === 40 ? <FiClock /> : step.percent >= 50 ? <FiCheck /> : <FiX /> }
                </span>
                <p>That you have signed your contract with felloh, sent via email (from sign request).</p>
              </div>

              <div className="education__content">
                <h5>Merchant Acquirer Onboarding</h5>
                <span className={ step.percent >= 50 && step.percent < 80 ? 'year pending' : step.percent >= 80 ? 'year tick' : 'year' }>
                  { step.percent === 50 ? <FiClock /> : step.percent >= 80 ? <FiCheck /> : <FiX /> }
                </span>
                <p>That we have set up your account with one of our merchant acquirers.</p>
              </div>

              <div className="education__content">
                <h5>Credentials Sent</h5>
                <span className={ step.percent === 80 ? 'year pending' : step.percent >= 90 ? 'year tick' : 'year' }>
                  { step.percent === 80 ? <FiClock /> : step.percent >= 90 ? <FiCheck /> : <FiX /> }
                </span>
                <p>That your credentials to login to Felloh have been sent over to you.</p>
              </div>

              <div className="education__content !border-b-0">
                <h5>Ready to process transactions</h5>
                <span className={ step.percent === 90 ? 'year pending' : step.percent >= 100 ? 'year tick' : 'year' }>
                  { step.percent === 90 ? <FiClock /> : step.percent >= 100 ? <FiCheck /> : <FiX /> }
                </span>
                <p>That you are ready to begin processing transactions via Felloh.</p>
              </div>
            </div>

          </React.Fragment>
        )}
      </div>
    </Fragment>
  );
}

export default App;
